import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newplaceholder.svg'
import _imports_1 from '@/assets/svg-copyright.svg'
import _imports_2 from '@/assets/pd.svg'
import _imports_3 from '@/assets/cc.svg'
import _imports_4 from '@/assets/by.svg'
import _imports_5 from '@/assets/sa.svg'
import _imports_6 from '@/assets/nc.svg'
import _imports_7 from '@/assets/nd.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f996a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid-gallery": "",
  class: "gallery"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "loader-container"
}
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "gallery-license-info"
}
const _hoisted_11 = {
  key: 0,
  class: "artwork-copyright"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Copyright"
}, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "artwork-copyright"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Copyright"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Til fri brug", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "artwork-copyright"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Copyright"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Copyright"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://creativecommons.org/licenses/by/4.0/",
    target: "_blank"
  }, " Visse rettigheder forbeholdes ")
], -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 3,
  class: "artwork-copyright"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Copyright"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Copyright"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Copyright"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://creativecommons.org/licenses/by-sa/4.0/",
    target: "_blank"
  }, " Visse rettigheder forbeholdes ")
], -1))
const _hoisted_27 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 4,
  class: "artwork-copyright"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Copyright"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Copyright"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Copyright"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://creativecommons.org/licenses/by-nc/4.0",
    target: "_blank"
  }, " Visse rettigheder forbeholdes ")
], -1))
const _hoisted_33 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 5,
  class: "artwork-copyright"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Copyright"
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Copyright"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "Copyright"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://creativecommons.org/licenses/by-nd/4.0/",
    target: "_blank"
  }, " Visse rettigheder forbeholdes ")
], -1))
const _hoisted_39 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 6,
  class: "artwork-copyright"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_3 + "\" alt=\"Copyright\" data-v-0f996a6c><img src=\"" + _imports_4 + "\" alt=\"Copyright\" data-v-0f996a6c><img src=\"" + _imports_6 + "\" alt=\"Copyright\" data-v-0f996a6c><img src=\"" + _imports_5 + "\" alt=\"Copyright\" data-v-0f996a6c><span data-v-0f996a6c><a href=\"https://creativecommons.org/licenses/by-nc-sa/4.0/\" target=\"_blank\" data-v-0f996a6c> Visse rettigheder forbeholdes </a></span>", 5)
const _hoisted_46 = [
  _hoisted_41
]
const _hoisted_47 = {
  key: 7,
  class: "artwork-copyright"
}
const _hoisted_48 = {
  key: 1,
  "data-testid-gallery-thumbnails": "",
  class: "gallery-thumbnails"
}
const _hoisted_49 = { class: "gallery-thumbnails-container" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FullScreenImageModal = _resolveComponent("FullScreenImageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-testid-gallery-images": "",
      class: _normalizeClass(["gallery-images mb-3", { multiple: _ctx.isMultiple() }])
    }, [
      (_ctx.isMultiple())
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            "data-testid-button-prev": "",
            class: "prev",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
            type: "button",
            "aria-label": _ctx.$t('aria.global.previous')
          }, _hoisted_4, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "gallery-images-slider",
        ref: "container",
        onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
        style: _normalizeStyle(_ctx.loading ? '' : 'scroll-behavior: smooth;')
      }, [
        (!!_ctx.images.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.images, (image) => {
              return (_openBlock(), _createElementBlock("img", {
                "data-testid-gallery-images-img": "",
                class: _normalizeClass(["gallery-image", { loaded: !_ctx.loading }]),
                key: image,
                src: _ctx.baseurl + image,
                alt: ""
              }, null, 10, _hoisted_5))
            }), 128))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              "data-testid-gallery-images-img": "",
              class: _normalizeClass(["gallery-image", { loaded: !_ctx.loading }]),
              src: _imports_0,
              alt: ""
            }, null, 2)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Spinner)
            ]))
          : _createCommentVNode("", true)
      ], 36),
      (_ctx.isMultiple())
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            "data-testid-button-next": "",
            class: "next",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
            type: "button",
            "aria-label": _ctx.$t('aria.global.next')
          }, _hoisted_9, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showLicenseInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.getCurrentLicense() == 'Copyright - C')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.getCurrentCreditations()) + " / VISDA ", 1)
              ]))
            : (
                    _ctx.getCurrentLicense() == 'Public Domain - PD' ||
                    _ctx.getCurrentLicense() == 'No Known Copyrights - NKC'
                )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
              : (
                    _ctx.getCurrentLicense() == 'Creative Commons - CC BY' && _ctx.objectTemplate == 'ART'
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
                : (
                    _ctx.getCurrentLicense() == 'Creative Commons - CC BY-SA' && _ctx.objectTemplate == 'ART'
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_27))
                  : (
                    _ctx.getCurrentLicense() == 'Creative Commons - CC BY-NC' && _ctx.objectTemplate == 'ART'
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_33))
                    : (
                    _ctx.getCurrentLicense() == 'Creative Commons - CC BY-ND' && _ctx.objectTemplate == 'ART'
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_39))
                      : (
                    _ctx.getCurrentLicense() == 'Creative Commons - CC BY-NC-SA' && _ctx.objectTemplate == 'ART'
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_46))
                        : (_openBlock(), _createElementBlock("div", _hoisted_47))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMultiple())
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, i) => {
              return (_openBlock(), _createElementBlock("button", {
                "data-testid-gallery-thumbnails-button": "",
                class: "thumbnail",
                onClick: ($event: any) => (_ctx.display(i)),
                key: image
              }, [
                _createElementVNode("img", {
                  "data-testid-gallery-thumbnails-img": "",
                  class: _normalizeClass(["thumbnail-image", { current: _ctx.highlightIndex === i }]),
                  src: _ctx.baseurl + image,
                  alt: ""
                }, null, 10, _hoisted_51)
              ], 8, _hoisted_50))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modal)
      ? (_openBlock(), _createBlock(_component_FullScreenImageModal, {
          key: 2,
          image: _ctx.images[_ctx.current],
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modal', false)))
        }, null, 8, ["image"]))
      : _createCommentVNode("", true)
  ]))
}